import ContentsDashboard from "../pages/Contents/Dashboard";
import Dashboard from "../pages/Dashboard";
import HealthTable from "../pages/HealthTable";
import HealthWeek from "../pages/Contents/HealthWeek";
import Levels from "../pages/Levels";
import Login from "../pages/Auth/Login";
import Logout from "../pages/Auth/Logout";
import ProfileConfig from "../pages/ProfileConfig";
import Ranking from "../pages/Ranking/Ranking";
import React from "react";
import { Redirect } from "react-router-dom";
import TrackerProvider from "../pages/Contents/TrackerProvider";
import MonthlyChallenges from "../pages/MonthlyChallenges/MonthlyChallenges";
import Kiosk from "../pages/Kiosk";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/kiosk", exact: true, component: Kiosk },
  { path: "/profile", component: ProfileConfig },
  { path: "/levels/:id", component: Levels },
  { path: "/healthTable", component: HealthTable },
  { path: "/contents", exact: true, component: ContentsDashboard },
  {
    path: "/healthweek",
    component: () => (
      <TrackerProvider>
        <HealthWeek />
      </TrackerProvider>
    ),
  },
  { path: "/monthly-challenges", exact: true, component: MonthlyChallenges },
  { path: "/ranking/:filter", component: Ranking },
  { path: "/", exact: true, component: () => <Redirect to="/ranking/steps" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  // { path: "/forget-password", component: ForgetPass },
  // { path: "/register", component: Register }
];

export { authProtectedRoutes, publicRoutes };
